module.exports = __webpack_public_path__ + "img/wechat.6acdf9a7.png";